import {storedFileService} from '_app/services';
import * as actionTypes from './htmlMediaContentConstants';

export const fetchHtmlContent = storedFileID => dispatch => {
	dispatch(fetchHtmlMediaContentRequest);

	return storedFileService.getStringData(storedFileID)
		.then(response => {
			dispatch(fetchHtmlMediaContentSuccess(response.data));
		})
		.catch(error => {
			dispatch(fetchHtmlMediaContentFailure(error));
		});
};

const fetchHtmlMediaContentRequest = {
	type: actionTypes.HTML_MEDIA_CONTENT_FETCH_REQUEST
};

const fetchHtmlMediaContentSuccess = data => ({
	type: actionTypes.HTML_MEDIA_CONTENT_FETCH_SUCCESS,
	data
});

const fetchHtmlMediaContentFailure = error => ({
	type: actionTypes.HTML_MEDIA_CONTENT_FETCH_FAILURE,
	errorInfo : error
});